import React from 'react';
import { useSelector } from 'react-redux';
import { Link as v4Link } from 'react-router-dom';

// Multibrand-UI Components
import PageNotFound from '@zg-rentals/multibrand-ui/lib/PageNotFound';

import HeadWrapper from 'app/shared/components/HeadWrapper';
import Page from 'app/shared/containers/Page';

// Selectors
import { AppSelectors } from 'app/shared/selectors';

const NotFoundPage = () => {
    const brand = useSelector(state => ({
        brand: AppSelectors.makeBrand(state),
    }));

    return (
        <Page noPadding={true} className="NotFoundPage">
            <HeadWrapper title="Page not found" />
            <PageNotFound reactRouterLink={v4Link} brand={brand} />
        </Page>
    );
};

export default NotFoundPage;
